__turbopack_context__.v({
  "className": "inter_d54d3358-module__MwmiRW__className",
});
